const environment = process.env.NODE_ENV;
const isDev = environment === 'development';

const URL_PREVIEW_CLOUD_DEV = "http://localhost:3000/static/";
const URL_PREVIEW_CLOUD_PROD = "https://scoreboard-prod.infobae.com/static/";
export const URL_PREVIEW_CLOUD = isDev ? URL_PREVIEW_CLOUD_DEV : URL_PREVIEW_CLOUD_PROD;

// export const URL_BASE_PREVIEW_STATIC = "https://storage.googleapis.com/data-data-factory-infobae";

const URL_BASE_API_DEV = "https://marcadores-data.infobae.com";
// const URL_BASE_API_PROD = "https://us-central1-marcadores-377319.cloudfunctions.net/marcadores-api";
// const URL_BASE_API_PROD = "https://marcadores-api.infobae.com";
const URL_BASE_API_PROD = "https://marcadores-data.infobae.com";
export const URL_BASE_API = isDev ? URL_BASE_API_DEV : URL_BASE_API_PROD;

export const URL_BASE_BACKEND_API_DEV = "https://marcadores-api.infobae.com";
